/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Search = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 19 20">
      <path d="M7.95996 15.5254C9.59082 15.5254 11.0947 14.998 12.3252 14.1191L16.9541 18.748C17.1689 18.9629 17.4521 19.0703 17.7549 19.0703C18.3896 19.0703 18.8389 18.582 18.8389 17.957C18.8389 17.6641 18.7412 17.3906 18.5264 17.1758L13.9268 12.5664C14.8936 11.2969 15.4697 9.72461 15.4697 8.01562C15.4697 3.88477 12.0908 0.505859 7.95996 0.505859C3.8291 0.505859 0.450195 3.88477 0.450195 8.01562C0.450195 12.1465 3.8291 15.5254 7.95996 15.5254ZM7.95996 13.9043C4.7373 13.9043 2.07129 11.2383 2.07129 8.01562C2.07129 4.79297 4.7373 2.12695 7.95996 2.12695C11.1826 2.12695 13.8486 4.79297 13.8486 8.01562C13.8486 11.2383 11.1826 13.9043 7.95996 13.9043Z" />
    </BaseSvgIcon>
  )
}

export default Search
